import { updateGrade } from '@/services/grade.service';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Drawer, Form, Button } from 'rsuite';
import { useTranslation } from 'react-i18next';


interface EditDrawerViewProps {
  open: boolean;
  onClose: () => void;
  grade: any;
}

const EditDrawerView: React.FC<EditDrawerViewProps> = ({ open, onClose, grade }) => {
  const dispatch = useDispatch();
  const [formValue, setFormValue] = React.useState({
    grade_name: grade?.grade_name || ''
  });

  React.useEffect(() => {
    if (grade) {
      setFormValue({
        grade_name: grade.grade_name || ''
      });
    }
  }, [grade]);

  const handleSubmit = () => {
    if (grade && grade._id) {
      dispatch(
        updateGrade(grade._id, {
          grade_name: formValue.grade_name
        })
      );
      onClose();
    }
  };
  const { t } = useTranslation();






  return (
    <Drawer backdrop="static" size="sm" placement="right" onClose={onClose} open={open}>
      <Drawer.Header>
        <Drawer.Title>{t('Edit Grade')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={handleSubmit} appearance="primary">
            {t('Save')}
          </Button>
          <Button onClick={onClose} appearance="subtle">
            {t('Cancel')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Form fluid formValue={formValue} onChange={setFormValue}>
          <Form.Group>
            <Form.ControlLabel>{t('Grade Name')}</Form.ControlLabel>
            <Form.Control name="grade_name" placeholder={t("Enter grade name")} />
          </Form.Group>
        </Form>
      </Drawer.Body>
    </Drawer>
  );
};

export default EditDrawerView;
